import {
  DocumentIcon,
  ChatBubbleLeftRightIcon,
  PaintBrushIcon,
} from '@heroicons/react/24/outline'

const FEATURES = [
  {
    icon: DocumentIcon,
    title: 'Add your content',
    description: 'Import your website or documents so your assistant knows your business.',
  },
  {
    icon: ChatBubbleLeftRightIcon,
    title: 'Preview your assistant',
    description: 'Test how your AI assistant responds to questions from your visitors.',
  },
  {
    icon: PaintBrushIcon,
    title: 'Customize & install',
    description: 'Match your brand colors, name your assistant, and add it to your site.',
  },
]

export default function Step1Welcome({ user, onNext }) {
  const displayName = user?.fullName || user?.full_name || user?.email?.split('@')[0] || 'there'

  return (
    <div className="text-center py-4">
      <h2 className="text-2xl font-bold text-slate-900 mb-2">
        Hi {displayName}!
      </h2>
      <p className="text-lg text-slate-600 mb-8">
        Let's set up your AI assistant
      </p>

      <div className="space-y-4 mb-10 text-left max-w-md mx-auto">
        {FEATURES.map(({ icon: Icon, title, description }) => (
          <div key={title} className="flex items-start gap-4 p-4 rounded-xl bg-slate-50">
            <div className="flex-shrink-0 w-10 h-10 rounded-lg bg-indigo-100 flex items-center justify-center">
              <Icon className="h-5 w-5 text-indigo-600" />
            </div>
            <div>
              <h3 className="font-semibold text-slate-900">{title}</h3>
              <p className="text-sm text-slate-500 mt-0.5">{description}</p>
            </div>
          </div>
        ))}
      </div>

      <button
        onClick={() => onNext()}
        className="inline-flex items-center justify-center px-8 py-3 bg-indigo-600 text-white font-semibold rounded-xl hover:bg-indigo-700 transition-colors shadow-lg shadow-indigo-200"
      >
        Get Started
      </button>
    </div>
  )
}
